import React from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { useForm } from "react-hook-form";

import WSSelectField from "../../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSDateField from "../../../Components/DateField/WSDateField";
import config from "../../../Config/clientConfig.json"

const ChequeStatus = () => {
    const { control ,register} = useForm();

    

    return (
        <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>

            {}
            <Box display="flex" justifyContent="space-between" mb={4}>
                <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                    Customer Management
                </Typography>

                <Box>
                    <IconButton sx={{ background: "#000", color: "#fff", mr: 1 }}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton sx={{ background: "#000", color: "#fff" }}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            {}
            <Paper
                sx={{
                    borderRadius: "16px",
                    p: 3,
                    background: "#fafafa",
                }}
            >
                {}
                <Box display="flex" justifyContent="space-between" mb={7}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
                        Customer Details
                    </Typography>

                    <IconButton sx={{ background: "#000", color: "#fff" }}>
                        <SaveIcon fontSize="small" />
                    </IconButton>
                </Box>

                <Grid container rowSpacing={8} columnSpacing={5}>

                    <Grid item xs={4}>
                        <WSTextField
                            name="bankname"
                            label="Bank Name"
                            id="bankname"
                            control={control}

                        />
                    </Grid>

                   <Grid item xs={4}>
                        <WSTextField
                            name="branch"
                            label="Branch"
                            id="branch"
                            control={control}

                        />
                    </Grid>

                    
                  
                    
                      
                    <Grid item xs={4}>
                        <WSTextField
                            name="chequenumber"
                            label="Cheque Number"
                            id="chequenumber" control={control}
                            type={TextType.AllowOnlyNumber}
                             />
                    </Grid>

                     <Grid item xs={4}>
                        <WSTextField
                            name="accno"
                            label="Account Number"
                            id="accno" control={control}
                            type={TextType.AllowOnlyNumber}
                             />
                    </Grid>
                     <Grid item xs={4}>
                        <WSTextField
                            name="ifsc"
                            label="IFSC Code"
                            id="ifsc" control={control}
                           
                             />
                    </Grid>

                    <Grid item xs={4}>
                        <WSDateField
                            name="date"
                            label="Issue Date"
                            id="date" control={control} rules={undefined}                           
                             />
                    </Grid>

                    <Grid item xs={4}>
                        <WSTextField
                            name="amount"
                            label="Amount"
                            id="amount" control={control}
                            type={TextType.AllowOnlyNumber}
                             />
                    </Grid>
         

                   <Grid item xs={4}>
                        <WSSelectField
                            name="status"
                            label="Status"
                            id="status"
                            control={control}
                            options={config.statusConfig.staticOptionData}

                        />
                    </Grid>

                </Grid>
            </Paper>
        </Box>
    );
};

export default ChequeStatus;

